import { format } from 'date-fns';
import { TFunction } from 'i18next';
import { MenuConfig } from '../lib/components';
import {
  BenefitsIconSvg,
  DashboardIconSvg,
  PersonalDataIconSvg,
  ReceiptsIconSvg
} from '../lib/icons';

export const profileSubmenuConfig = (
  t: TFunction,
  employeeId: string | null | undefined,
  date?: Date,
  receiptsDisabled?: boolean
): MenuConfig => {
  const searchParams = date ? `?date=${format(date, 'yyyy-MM')}` : '';
  const keepEdit = () => (window.location.pathname.includes('edit') ? '/edit' : '');

  return [
    {
      title: t('common:DASHBOARD'),
      isActive: ({ pathname }) => /\/employees\/(me|[0-9a-f-]+?)\/dashboard/.test(pathname),
      link: `/employees/${employeeId}/dashboard${searchParams}`,
      icon: DashboardIconSvg
    },
    {
      title: t('common:PROFILE'),
      isActive: ({ pathname }) => /\/employees\/(me|[0-9a-f-]+?)\/data/.test(pathname),
      icon: PersonalDataIconSvg,
      config: [
        {
          title: t('common:PERSONAL_DATA'),
          isActive: ({ pathname }) => /\/data\/personal(\/edit)?$/.test(pathname),
          link: `/employees/${employeeId}/data/personal${keepEdit()}`
        },
        {
          title: t('employee:CONTACT_DATA'),
          isActive: ({ pathname }) => /\/data\/contact(\/edit)?$/.test(pathname),
          link: `/employees/${employeeId}/data/contact${keepEdit()}`
        },
        {
          title: t('employee:ADDRESS'),
          isActive: ({ pathname }) => /\/data\/address(\/edit)?$/.test(pathname),
          link: `/employees/${employeeId}/data/address${keepEdit()}`
        },
        {
          title: t('company:TAX_DATA'),
          isActive: ({ pathname }) => /\/data\/tax(\/edit)?$/.test(pathname),
          link: `/employees/${employeeId}/data/tax${keepEdit()}`
        },
        {
          title: t('employee:POSITION_DATA'),
          isActive: ({ pathname }) => /\/data\/position(\/edit)?$/.test(pathname),
          link: `/employees/${employeeId}/data/position${keepEdit()}`
        },
        {
          title: t('employee:PROFILE_PICTURE'),
          isActive: ({ pathname }) => /\/data\/picture(\/edit)?$/.test(pathname),
          link: `/employees/${employeeId}/data/picture`
        },
        {
          title: t('company:GROUPS'),
          isActive: ({ pathname }) => /\/data\/groups(\/edit)?$/.test(pathname),
          link: `/employees/${employeeId}/data/groups${keepEdit()}`
        }
      ]
    },
    {
      title: t('common:BENEFIT'),
      isActive: ({ pathname }) => /\/employees\/(me|[0-9a-f-]+?)\/benefits/.test(pathname),
      icon: BenefitsIconSvg,
      config: [
        {
          title: t('common:OVERVIEW'),
          isActive: ({ pathname }) => /\/benefits\/overview/.test(pathname),
          link: `/employees/${employeeId}/benefits/overview${searchParams}`
        },
        {
          title: t('common:BUDGET'),
          isActive: ({ pathname }) => /\/benefits\/budget/.test(pathname),
          link: `/employees/${employeeId}/benefits/budget${searchParams}`
        }
      ]
    },
    {
      title: t('common:RECEIPTS'),
      isActive: ({ pathname }) => /\/employees\/(me|[0-9a-f-]*)[/]*receipts/.test(pathname),
      link: `/employees/${employeeId}/receipts${searchParams}`,
      icon: ReceiptsIconSvg,
      disabled: receiptsDisabled
    }
  ];
};
